import React from 'react';
import {
    OnboarderTemplate,
    OnboarderTemplateData,
    ProjectData,
    EventData,
    TestimonialData,
    CommunityData,
} from '../../templates/OnboarderTemplate';
import { useConfig } from '../../hooks/useConfig';
import siteConfig from '../../../site.config.json';

// Map site.config.json to OnboarderTemplateData
const getOnboarderData = (
    projects?: ProjectData[],
    events?: EventData[],
    testimonials?: TestimonialData[],
    communities?: CommunityData[],
): OnboarderTemplateData => {
    return {
        identity: {
            name: siteConfig.identity.name,
            handle: siteConfig.identity.handle,
            avatar: siteConfig.identity.avatar,
            welcome: siteConfig.identity.welcome,
            bio: siteConfig.identity.bio,
        },
        hero: {
            welcome: siteConfig.identity.welcome,
            headline: siteConfig.content.heroHeadline,
            subline: siteConfig.content.heroSubtitle,
            ctaText: siteConfig.hero.ctaText,
            ctaLink: siteConfig.hero.ctaLink,
        },
        learningPath: siteConfig.learningPath.map(step => ({
            id: step.id,
            title: step.title,
            description: step.description,
            status: step.status as 'completed' | 'active' | 'upcoming',
            link: step.link,
            linkText: step.linkText,
        })),
        resources: siteConfig.resources.map(res => ({
            id: res.id,
            title: res.title,
            description: res.description,
            icon: res.icon,
            tag: res.tag,
            link: res.link,
        })),
        faq: siteConfig.faq.map(item => ({
            question: item.question,
            answer: item.answer,
        })),
        newsletter: {
            title: siteConfig.newsletter.title,
            description: siteConfig.newsletter.description,
            buttonText: siteConfig.newsletter.buttonText,
        },
        social: {
            twitter: siteConfig.social.twitter,
            youtube: siteConfig.social.youtube,
            discord: siteConfig.social.discord,
            telegram: siteConfig.social.telegram,
            telegramBusiness: siteConfig.social.telegramBusiness,
            patreon: siteConfig.social.patreon,
        },
        // Pass through admin-editable content from database
        projects,
        events,
        testimonials,
        communities,
    };
};

const OnboarderDemo: React.FC = () => {
    const { rawConfig } = useConfig();

    // Extract admin-editable arrays from config (if available)
    const projects = rawConfig?.projects as ProjectData[] | undefined;
    const events = rawConfig?.events as EventData[] | undefined;
    const testimonials = rawConfig?.testimonials as TestimonialData[] | undefined;
    const communities = rawConfig?.communities as CommunityData[] | undefined;

    // Build data with dynamic content from DB
    const data = getOnboarderData(projects, events, testimonials, communities);

    // Show template even while loading - it will use fallback data
    return <OnboarderTemplate data={data} />;
};

export default OnboarderDemo;
